// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JM-z","carouselContainer":"KM-z"};